import SettingsIndex from "./views/SettingsIndex";
import productRoutes from "@/modules/products/routes.js";
import auditlogRoutes from "@/modules/auditlog/routes.js";

const routes = [
  {
    path: "/settings",
    component: () => import(/* webpackChunkName: "SettingsIndex" */ "./views/SettingsIndex"),
    children: [
      {
        path: "client_card_settings",
        name: "client_card_settings",
        component: () => import(/* webpackChunkName: "ClientCardSettings" */ "./views/clientFields/ClientCardSettings")
      },
      {
        path: "sms_settings",
        name: "sms_settings",
        component: () => import(/* webpackChunkName: "SmsSettings" */ "./views/smsSettings/SmsSettings")
      },
      {
        path: "automation",
        name: "automation",
        component: () => import(/* webpackChunkName: "AutomationSettings" */ "./views/automation/AutomationSettings")
      },
      {
        path: "change-password",
        name: "change-password",
        component: () => import(/* webpackChunkName: "ChangePassword" */ "./views/changePassword/ChangePassword")
      },
      ...productRoutes,
      ...auditlogRoutes,
      {
        path: "*",
        redirect: { name: "client_card_settings" }
      }
    ]
  }
];
export default routes;
